module.exports = __webpack_public_path__ + "img/quizz_foot_logo.46684ac9.png";